/* import * as types from "./mutation-types"; */

export default {
  user(state, new_value){
    state.user = new_value
  },
  async user_files(state, new_value){

    // aspetta 1 secondo
    state.user_files = []
    await new Promise(resolve => setTimeout(resolve, 10));
    state.user_files = new_value
  },
  user_files_imgs(state, new_value){
    state.user_files['casting/foto'] = new_value
  },
  user_files_videos(state, new_value){
    state.user_files['casting/video'] = new_value
  },
  user_files_altro(state, new_value){
    state.user_files['casting/altro'] = new_value
  },
  user_files_cv(state, new_value){
    state.user_files['casting/cv'] = new_value
  },
  user_files_ci(state, new_value){
    state.user_files['casting/ci'] = new_value
  },
  change_key_user(state, new_values){

    if(!new_values)
      return

    for (const [key, value] of Object.entries(new_values.data)) {
      state.user[key] = value
    }

  },
  imgs(state, new_value){
    state.imgs = new_value
  },
  logout(state){
    state.user = null
    state.user_files = null
    state.imgs = []
  }
};
